enum CalculationMode {
    PostalCodeByRateSelection = 'postalCode.rateSelection',
    PostalCodeRatePriority = 'postalCode.ratePriority',
}

export default CalculationMode
